import {Action, handleActions} from "redux-actions";
import {ManagerStrategiesActionTypes} from "./ManagerStrategiesActions";
import {DEFAULT_RESEARCH_PAGINATION, IResearchPageState} from "../../model/ResearchPageState.model";

export interface IManagerStrategiesState extends IResearchPageState {
    managerId: number | undefined;
}

export const initialState: IManagerStrategiesState = {
    managerId: undefined,
    facetedFilters: {},
    searchText: "",
    pagination: DEFAULT_RESEARCH_PAGINATION,
    scrollToBackstopId: undefined,
};

const setScrollToBackstopId = (state: IManagerStrategiesState, action: Action<IManagerStrategiesState>):
    IManagerStrategiesState => {
    return {
        ...state,
        managerId: action.payload ? action.payload.managerId : initialState.managerId,
        scrollToBackstopId: action.payload ? action.payload.scrollToBackstopId : initialState.scrollToBackstopId,
    };
};

const updatePagination = (state: IManagerStrategiesState, action: Action<IManagerStrategiesState>):
    IManagerStrategiesState => {
    return {
        ...state,
        managerId: action.payload ? action.payload.managerId : initialState.managerId,
        pagination: action.payload ? action.payload.pagination : initialState.pagination,
    };
};

const updateFacetedFilters = (state: IManagerStrategiesState, {payload}: Action<IManagerStrategiesState>):
    IManagerStrategiesState => {
    return {
        ...state,
        managerId: payload ? payload.managerId : initialState.managerId,
        facetedFilters: payload ? payload.facetedFilters : initialState.facetedFilters,
        pagination: {...state.pagination, pageIndex: 0},
    };
};

const updateSearchText = (state: IManagerStrategiesState, {payload}: Action<IManagerStrategiesState>):
    IManagerStrategiesState => {
    return {
        ...state,
        managerId: payload ? payload.managerId : initialState.managerId,
        searchText: payload ? payload.searchText : initialState.searchText,
        pagination: {...state.pagination, pageIndex: 0},
    };
};

const clearStrategies = (state: IManagerStrategiesState, {}: Action<{}>): IManagerStrategiesState => {
    return {
        ...state,
        managerId: initialState.managerId,
        facetedFilters: initialState.facetedFilters,
        searchText: initialState.searchText,
        pagination: initialState.pagination,
        scrollToBackstopId: initialState.scrollToBackstopId,
    };
};

const clearAllFilters = (state: IManagerStrategiesState, {payload}: Action<IManagerStrategiesState>):
    IManagerStrategiesState => {
    return {
        ...state,
        managerId: payload ? payload.managerId : state.managerId,
        facetedFilters: {},
        searchText: "",
        pagination: {...state.pagination, pageIndex: 0},
    };
};

const reducerMap = {
    [ManagerStrategiesActionTypes.UPDATE_MANAGER_STRATEGIES_FACETED_FILTERS]: updateFacetedFilters,
    [ManagerStrategiesActionTypes.CLEAR_MANAGER_STRATEGIES]: clearStrategies,
    [ManagerStrategiesActionTypes.UPDATE_MANAGER_STRATEGIES_SEARCH_TEXT]: updateSearchText,
    [ManagerStrategiesActionTypes.UPDATE_MANAGER_STRATEGIES_PAGINATION]: updatePagination,
    [ManagerStrategiesActionTypes.SET_MANAGER_STRATEGIES_SCROLL_TO]: setScrollToBackstopId,
    [ManagerStrategiesActionTypes.CLEAR_ALL_MANAGER_STRATEGIES_FILTERS]: clearAllFilters,
};

export default handleActions<IManagerStrategiesState, any>(reducerMap, initialState);
